// extracted by mini-css-extract-plugin
export default {"uuiTooltip":"uuiTooltip_uuiTooltip__DgC12","tooltip":"uuiTooltip_tooltip__a2UyE"};